export const trackPageView = (to, from, next) => {
  if (to.meta.pageTitle && typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({ pageTitle: to.meta.pageTitle })
  }

  window.dataLayer.push({ pagePath: to.fullPath })

  next()
}



// WEBPACK FOOTER //
// ./src/router/guards/analytics.js